<script>
const themes = ['voxy-light', 'voxy-dark'];

export default {
  name: 'UiThemeMixin',

  props: {
    theme: {
      type: String,
      default: 'voxy-dark',
      validator: value => themes.indexOf(value) !== -1,
    },
  },

  data() {
    return {
      defaultTheme: 'voxy-dark',
    };
  },
};
</script>
